import { Button, CheckboxEditor } from '@approvalmax/ui';
import { WorkflowStepOk } from '@approvalmax/ui/src/old/icons';
import { font } from 'modules/styles';
import SignupConsent from 'pages/auth/components/SignupConsent/SignupConsent';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
`;

export const TrialTitle = styled.div`
    ${font(24, '#000', 'semibold')};
`;

export const AdvantagesArea = styled.div`
    display: flex;
    margin-top: 10px;
    margin-bottom: 30px;
`;

export const AdvantageBlock = styled.div`
    ${font(12, '#384650', 'semibold')};

    & + & {
        margin-left: 12px;
    }
`;

export const Container = styled.form`
    display: flex;
    flex-flow: column;
    max-width: 100%;
    background: #fff;
    width: 280px;
    height: 100%;
    margin-right: 0;
`;

export const Title = styled.div`
    ${font(12, '#5e5c5c', 'semibold')}
    line-height: 1.33;
    margin-bottom: 4px;
`;

export const EditorContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const ValidationMessage = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    pointer-events: none;
    z-index: 1;
    ${font(12, '#923924', 'semibold')}
`;

export const SignupButton = styled(Button)`
    height: 32px;
    margin-top: 15px;
    margin-left: 0;
`;

export const Checkboxes = styled.div`
    ${font(11, '#000')}
    margin-top: 0;
`;

export const LastCheckboxEditor = styled(CheckboxEditor)`
    ${font(11, '#000')}
    margin-top: 20px;
`;

export const ExperimentalConsent = styled(SignupConsent)`
    margin-top: 20px;
`;

export const NoWrapLink = styled.a`
    white-space: nowrap;
`;

export const AdvantageIcon = styled(WorkflowStepOk)`
    margin-right: 4px;
    vertical-align: middle;
`;
